/// <amd-module name="VSS/Diagnostics/UI/Segment" />
export * from "./Components/Segment/Segment";
